import { all, takeLatest } from "redux-saga/effects";
import httpClient from "../services/http.client";
import * as Effects from "redux-saga/effects";
import { successMessage } from "../../utilities/notification";
import {
  ADD_ROLE,
  DELETE_ROLE,
  ROLE_DETAILS,
  ROLE_LIST,
  UPDATE_ROLE,
} from "../actions/role.actions.types";
import History from "../services/history";

const call = Effects.call;

function* roleList({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "roles/list",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* roleDetails({ payload: { id, callback } }) {
  const payload = {
    method: "get",
    url: `roles/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* addRole({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "roles",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });
  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    successMessage(result.message);
    History.navigate("/roles");
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* updateRole({ payload: { id, data, callback } }) {
  const payload = {
    data,
    method: "put",
    url: `roles/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      History.navigate("/roles");
      successMessage(result.message);
      callback({ success: true, data: result.data });
    }
  }
}

function* deleteRole({ payload: { id, callback } }) {
  const payload = {
    method: "delete",
    url: `roles/${id}?force=false`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    successMessage(result.message);
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* Role() {
  yield all([
    takeLatest(ROLE_LIST, roleList),
    takeLatest(ROLE_DETAILS, roleDetails),
    takeLatest(ADD_ROLE, addRole),
    takeLatest(UPDATE_ROLE, updateRole),
    takeLatest(DELETE_ROLE, deleteRole),
  ]);
}

export default Role;
